import React, { useMemo, useState } from 'react';

import cx from 'classnames';
import { debounce } from 'lodash';

// import { ReactComponent as FilterIcon } from 'pages/Teachers/ClassroomInsights/assets/filter-icon.svg';
import { ReactComponent as SearchIcon } from 'pages/Teachers/ClassroomInsights/assets/search-icon.svg';

import styles from './style.module.scss';

const StudentSearch = ({ students, nameValue = [], onStudentSelect }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(students);
  const [open, setOpen] = useState(false);
  const [selectedStudentsIds, setSelectedStudentsIds] = useState(nameValue);

  const runSearch = useMemo(
    () =>
      debounce((value) => {
        const v = value.toLowerCase();
        setResults(
          students.filter(
            (s) =>
              s.name.toLowerCase().includes(v) &&
              !selectedStudentsIds.includes(s.student_id)
          )
        );
        setOpen(true);
      }, 300),
    [students, selectedStudentsIds]
  );

  const onChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    runSearch(value);
  };

  const handleSelect = (student) => {
    const newSelected = [...selectedStudentsIds, student.student_id];
    setSelectedStudentsIds(newSelected);
    setQuery('');
    setResults([]);
    setOpen(false);
    onStudentSelect(newSelected);
  };

  const handleRemove = (studentId) => {
    const newSelected = selectedStudentsIds.filter((s) => s !== studentId);
    setSelectedStudentsIds(newSelected);
    onStudentSelect(newSelected);
  };

  const selectedStudents = useMemo(
    () => students?.filter((s) => selectedStudentsIds.includes(s.student_id)),
    [students, selectedStudentsIds]
  );

  return (
    <div
      className={cx(styles.container, {
        [styles.noOptionsSelected]: selectedStudentsIds.length === 0
      })}
    >
      <div className={styles.searchWrapper}>
        <div className={styles.searchInput}>
          {/* <FilterIcon /> */}
          <input
            type="text"
            placeholder="Search Students here..."
            value={query}
            onChange={onChange}
          />

          <SearchIcon />
        </div>

        {open && (
          <div className={styles.results}>
            {results.length === 0 && (
              <div className={cx(styles.result, styles.empty)}>
                No students found
              </div>
            )}
            {results.map((student, index) => (
              <div
                key={index}
                className={styles.result}
                onClick={() => handleSelect(student)}
              >
                {student.name}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={styles.selectedContainer}>
        {selectedStudents?.map((student, index) => (
          <div key={student.index} className={styles.selectedItem}>
            {student.name}
            <span
              className={styles.removeBtn}
              onClick={() => handleRemove(student.student_id)}
            >
              ×
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentSearch;
